export const emailsTemplatesTranslations = {
  es: {},
  en: {},
}